export class SeverityFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "containsAnyOf",
            "baseName": "containsAnyOf",
            "type": "Array<SeverityFilterValue>",
            "format": ""
        },
        {
            "name": "containsNoneOf",
            "baseName": "containsNoneOf",
            "type": "Array<SeverityFilterValue>",
            "format": ""
        },
        {
            "name": "containsAllOf",
            "baseName": "containsAllOf",
            "type": "Array<SeverityFilterValue>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SeverityFilters.attributeTypeMap;
    }
    constructor() {
    }
}
